import { useTranslation } from "react-i18next";
import { SignaturePdfDocument } from "./SignaturePdfDocument";

export interface SignatureDocumentProps {
  pdfAttachment?: string;
  signatureUrl?: string;
}

export const SignatureDocument = ({ pdfAttachment, signatureUrl }: SignatureDocumentProps) => {
  const { t } = useTranslation("forms");

  if (pdfAttachment) return <SignaturePdfDocument pdfAttachment={pdfAttachment} />;

  if (signatureUrl) {
    return (
      <div className="flex flex-col gap-1">
        <iframe title={t("Document to sign")} src={signatureUrl} className="w-full h-96 border rounded" />
        <a className="underline text-sm" href={signatureUrl} target="_blank" rel="noreferrer">
          {t("View document in new tab")}
        </a>
      </div>
    );
  }

  return null;
};
